import type { SavedChecklist, SavedAudit } from '@techgitter/contracts';

const API_BASE_URL = '/api';

export async function patchJobChecklist(
  jobGuid: string,
  checklist: SavedChecklist,
  audit: SavedAudit,
  signal?: AbortSignal,
): Promise<void> {
  const response = await fetch(
    `${API_BASE_URL}/jobs/${encodeURIComponent(jobGuid)}/checklist`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ checklist, audit }),
      signal,
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to save checklist: ${response.status} ${response.statusText}`);
  }
}
